var _rect, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAuthKey(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Icon"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_58605_12637",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Bounding box",
    width: 20,
    height: 20,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_58605_12637)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "encrypted",
    d: "M8.75065 12.5003H11.2507L10.7715 9.81283C11.0493 9.67394 11.268 9.47255 11.4277 9.20866C11.5875 8.94477 11.6673 8.6531 11.6673 8.33366C11.6673 7.87533 11.5041 7.48296 11.1777 7.15658C10.8513 6.83019 10.459 6.66699 10.0007 6.66699C9.54232 6.66699 9.14996 6.83019 8.82357 7.15658C8.49718 7.48296 8.33398 7.87533 8.33398 8.33366C8.33398 8.6531 8.41385 8.94477 8.57357 9.20866C8.73329 9.47255 8.95204 9.67394 9.22982 9.81283L8.75065 12.5003ZM10.0007 18.3337C8.0701 17.8475 6.47635 16.7399 5.2194 15.0107C3.96246 13.2816 3.33398 11.3614 3.33398 9.25033V4.16699L10.0007 1.66699L16.6673 4.16699V9.25033C16.6673 11.3614 16.0388 13.2816 14.7819 15.0107C13.525 16.7399 11.9312 17.8475 10.0007 18.3337ZM10.0007 16.5837C11.4451 16.1253 12.6395 15.2087 13.584 13.8337C14.5284 12.4587 15.0007 10.9309 15.0007 9.25033V5.31283L10.0007 3.43783L5.00065 5.31283V9.25033C5.00065 10.9309 5.47287 12.4587 6.41732 13.8337C7.36176 15.2087 8.55621 16.1253 10.0007 16.5837Z",
    fill: "#5F5C71"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAuthKey);
export default __webpack_public_path__ + "static/media/authKey.38a8a0798cd4eb603926b2782da54c21.svg";
export { ForwardRef as ReactComponent };